import gsap from 'gsap';

export default (el, options) => {

    let { animate = true } = options || {};

    const createPattern = () => {
        gsap.set(el, { clearProps: 'transform' });

        const { width, height } = el.getBoundingClientRect();

        const boxSize = Math.round(height / 2);
        let numBoxesX = Math.round(width / boxSize);
        if (numBoxesX % 2 === 0) {
            numBoxesX += 1;
        }
        const numBoxesY = 2;

        let html = '';

        for (let row = 0; row < numBoxesY; row += 1) {
            let rowHtml = '';
            for (let col = 0; col < numBoxesX; col += 1) {
                rowHtml += `<div class="flex-none${(row + col) % 2 === 0 ? ' bg-yellow' : ''}" style="width:${boxSize}px;height:${boxSize}px;"></div>`;
            }
            html += `<div class="flex">${rowHtml}</div>`;
        }

        el.innerHTML = html;

        // Scale the pattern so it exactly fits
        const scale = width / (boxSize * numBoxesX);
        gsap.set(el, { scale, transformOrigin: 'left bottom' });

        if (animate) {
            animate = false; // We only want to animate the first time its created

            const boxes = [];
            // Get the two child nodes (rows)
            const firstRowChildren = [...el.childNodes[0].querySelectorAll('.bg-yellow')].reverse();
            const secondRowChildren = [...el.childNodes[1].querySelectorAll('.bg-yellow')].reverse();

            // Interleave the children in the required order
            const maxLength = Math.max(firstRowChildren.length, secondRowChildren.length);
            for (let i = 0; i < maxLength; i += 1) {
                if (i < firstRowChildren.length) {
                    boxes.push(firstRowChildren[i]);
                }
                if (i < secondRowChildren.length) {
                    boxes.push(secondRowChildren[i]);
                }
            }

            const tween = gsap.fromTo(boxes, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.05,
                stagger: 0.1,
                ease: 'none'
            });

            gsap.to(tween, { progress: 1, ease: 'none', duration: 0.75 });
        }

        console.info('created pattern');
    };

    let prevWidth = null;
    let prevHeight = null;

    let observer = new ResizeObserver(([{ contentRect }]) => {
        if (el.offsetParent === null) {
            return;
        }

        const { width, height } = contentRect;
        if (width === prevWidth && height === prevHeight) {
            return;
        }

        prevWidth = width;
        prevHeight = height;

        createPattern();
    });
    observer.observe(el);

    const destroy = () => {
        observer.disconnect();
        observer = null;
        console.info('pattern destroyed');
    };

    return {
        el,
        destroy
    };

};
